import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupersetDashboardService {

  private URL = environment.api + "api/superset-dashboard";

  constructor(private http: HttpClient) { }

  getDashboard(dashboardId: any) {
    return this.http.get(`${this.URL}/${dashboardId}`)
  }
}
